/**
 * @generated SignedSource<<1138ee41029577d9428987bd547f8957>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditOnlySpecificPermissionsVisibilityTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  newDateTime: string;
  rootNodeId: string;
};
export type OnlySpecificPermissionsVisibilityConfigForm_EditMutation$variables = {
  input: EditOnlySpecificPermissionsVisibilityTreeConfigInput;
};
export type OnlySpecificPermissionsVisibilityConfigForm_EditMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly editOnlySpecificPermissionsVisibilityTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type OnlySpecificPermissionsVisibilityConfigForm_EditMutation = {
  response: OnlySpecificPermissionsVisibilityConfigForm_EditMutation$data;
  variables: OnlySpecificPermissionsVisibilityConfigForm_EditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnlySpecificPermissionsVisibilityConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditOnlySpecificPermissionsVisibilityTreeConfigPayload",
                "kind": "LinkedField",
                "name": "editOnlySpecificPermissionsVisibilityTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnlySpecificPermissionsVisibilityConfigForm_EditMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditOnlySpecificPermissionsVisibilityTreeConfigPayload",
                "kind": "LinkedField",
                "name": "editOnlySpecificPermissionsVisibilityTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "visibilityConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isVisibilityTreeConfig"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "configType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f4c8df147ae36809f77c81f5ff6ebf6",
    "id": null,
    "metadata": {},
    "name": "OnlySpecificPermissionsVisibilityConfigForm_EditMutation",
    "operationKind": "mutation",
    "text": "mutation OnlySpecificPermissionsVisibilityConfigForm_EditMutation(\n  $input: EditOnlySpecificPermissionsVisibilityTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      editOnlySpecificPermissionsVisibilityTreeConfig(input: $input) {\n        rootNode {\n          ...OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      visibilityConfigs {\n        __typename\n        ...OnlySpecificPermissionsVisibilityConfigForm_VisibilityTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment OnlySpecificPermissionsVisibilityConfigForm_VisibilityTreeConfigFragment on VisibilityTreeConfig {\n  __isVisibilityTreeConfig: __typename\n  ... on OnlySpecificPermissionsVisibilityTreeConfig {\n    id\n    configType\n    dateTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4f89ade9f99b4ceb9a8b5591b42d2bd";

export default node;
